import React from "react"
import { useSortable } from "@dnd-kit/react/sortable"
import moment from "moment"
import { User } from "lucide-react"
import NavigationLink from "~/library/NavigationLink"
import type Deal from "~/types/Deal"

const formatMoney = (value?: number | string | null) => {
    if (value == null) return "$0.00"
    const numValue = typeof value === "string" ? parseFloat(value) : value
    return `$${numValue.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
}

interface DraggableDealCardProps {
    deal: Deal
    index: number
    stageId: string
}

const DraggableDealCard: React.FC<DraggableDealCardProps> = ({
                                                                 deal,
                                                                 index,
                                                                 stageId,
                                                             }) => {
    const { ref } = useSortable({
        id: deal.id,
        index,
        type: "deal",
        accept: "deal",
        group: stageId,
    })

    return (
        <div ref={ref}>
            <div
                className="card mb-2 shadow-sm text-white"
                style={{
                    cursor: 'grab'
                }}
            >
                <div className="card-body p-2">
                    <div className="d-flex justify-content-between align-items-start mb-1">
                        <NavigationLink type="deals" to={`/deals/${deal.prefixId}`}>
                            <small className="fw-bold">{deal.name}</small>
                        </NavigationLink>
                    </div>

                    {deal.account && (
                        <div className="text-muted font-12 mb-1">
                            {deal.account.name}
                        </div>
                    )}

                    {deal.salesRep && (
                        <div className="d-flex align-items-center text-muted font-11 mb-1">
                            <User size={12} className="me-1" />
                            <span>{deal.salesRep.fullName}</span>
                        </div>
                    )}

                    <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-bold text-success">{formatMoney(deal.value)}</span>
                        {deal.probability && (
                            <span className="badge bg-secondary font-11">{deal.probability}%</span>
                        )}
                    </div>

                    {deal.expected_close_date && (
                        <div className="text-muted font-11 mt-1">
                            Close: {moment(deal.expected_close_date).format("MMM DD")}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default DraggableDealCard
